import React from 'react'
import {useNavigate} from "react-router-dom"
const GoToSimulation = () => {  
  const navigate = useNavigate();
  return (
    <div className="div_goToSimulation">
        <button className="btn_goToSimulation" onClick={()=>navigate("simulation")} id="goToSimulation">Go to Simulation</button>
    </div>
  )
}

export default GoToSimulation